export { default as homeIcon } from "./images/general/home_icon.svg";
export { default as searchIcon } from "./images/general/search_icon.svg";
export { default as facebookIcon } from "./images/general/facebook.svg";
export { default as instagramIcon } from "./images/general/instagram.svg";
export { default as linkedInIcon } from "./images/general/linkedIn.svg";
export { default as leftArrow } from "./images/general/left_arrow.svg";
export { default as rightArrow } from "./images/general/right_arrow.svg";
export { default as leftArrowWhite } from "./images/general/left_arrow_white.svg";
export { default as rightArrowWhite } from "./images/general/right_arrow_white.svg";
export { default as playIcon } from "./images/general/play_icon.svg";
export { default as playIconGreen } from "./images/general/play_icon_green.svg";
export { default as spotify } from "./images/general/spotify.svg";
export { default as pinterest } from "./images/general/pinterest.svg";
export { default as radio } from "./images/general/radio.svg";
export { default as greenDownArrow } from "./images/general/green_down_arrow.svg";
export { default as whiteDownArrow } from "./images/general/white_down_arrow.svg";
export { default as filterIcon } from "./images/general/filter_icon.svg";
export { default as downArrowBlack } from "./images/general/down_arrow_black.svg";
export { default as pathwaysLogo } from "./images/general/pathways_logo.svg";
export { default as pathwaysLogoGreen } from "./images/general/pathways_logo_green.svg";
export { default as closeIcon } from "./images/general/menu_close.svg";
export { default as facebookIconWhite } from "./images/general/facebook_1.svg";
export { default as instagramWhite } from "./images/general/instagram_1.svg";
export { default as linkedInWhite } from "./images/general/linkedIn_1.svg";
export { default as youtubeWhite } from "./images/general/youtube.svg";
export { default as tiktokWhite } from "./images/general/listen.svg";
export { default as upArrowGreen } from "./images/general/green_up_arrow.svg";
export { default as palyerCloseIcon } from "./images/general/close_icon.svg";

// VIDEOS
export { default as demoVideo } from "./video/demo-video.mp4";
export { default as calendar } from "./images/general/calendar.svg";
export { default as clock } from "./images/general/clock.svg";

// Home Page Images
export { default as homeBanner } from "./images/home/banner.jpg";
export { default as homeBannerMb } from "./images/home/mb_banner.jpg";
export { default as homeBannerOverlay } from "./images/home/banner_overlay.jpg";
export { default as playicon } from "./images/home/play-icon.svg";
export { default as explorearrow } from "./images/home/explore-arrow.svg";
export { default as explorearrowGreen } from "./images/home/explore-arrow-green.svg";
export { default as quoteicon } from "./images/home/quote-icon.svg";

// Common Banner Images
export { default as commonBanner } from "./images/general/common_banner.jpg";
export { default as commonBannerMob } from "./images/general/common_banner_mb_1.png";

// About Us Page Images
export { default as aboutSec01 } from "./images/about-us/about_sec1.jpg";
export { default as mbAboutSec01 } from "./images/about-us/mb_about_sec1.png";
export { default as aboutSec02 } from "./images/about-us/about_sec2.jpg";
export { default as missionIcon } from "./images/about-us/mision.svg";
export { default as visionIcon } from "./images/about-us/vision.svg";
export { default as aboutLinkedIn } from "./images/about-us/linkedIn.svg";
export { default as horzontalOrangeLine } from "./images/about-us/horizontal_line_orange.svg";
export { default as horzontalWhiteLine } from "./images/about-us/horizontal_line_white.svg";
export { default as verticalOrangeLine } from "./images/about-us/vertical_line_orange.svg";
export { default as verticalWhiteLine } from "./images/about-us/vertical_line_white.svg";
export { default as sun } from "./images/about-us/circle_with_triangle.svg";
export { default as upDownArrow } from "./images/about-us/up_down_arrow.svg";
export { default as upDownArrowLightGreen } from "./images/about-us/up_down_arrow_light_green.svg";
export { default as flower } from "./images/about-us/flower.svg";

// Interviews Page Images
export { default as listenBg } from "./images/interviews/listen_bg.png";

// Reflections Page Images
export { default as interviewFormBg } from "./images/Reflections/young-sports.png";

// PopUp
export { default as xmarkIcon } from "./images/Popup/xmarkicon.svg";

export let images = {
  // Home page Images
  skiddle: {
    image: require("./images/home/skiddle.png"),
    alt: "skiddle",
  },
  overleaf: {
    image: require("./images/home/overleaf.png"),
    alt: "overleaf",
  },
  optica: {
    image: require("./images/home/optica.png"),
    alt: "optica",
  },
  ayvens: {
    image: require("./images/home/ayvens.png"),
    alt: "ayvens",
  },
  tradingView: {
    image: require("./images/home/trading_view.png"),
    alt: "trading view",
  },
  videothumb: {
    image: require("./images/home/video-thumb.jpg"),
    alt: "video thumb",
  },
  videothumbMb: {
    image: require("./images/home/video-thumb_mobile.png"),
    alt: "video thumb",
  },
  event01: {
    image: require("./images/home/tommy_rosen.png"),
    alt: "tommy rosen",
  },
  event02: {
    image: require("./images/home/dr_ramkumar.png"),
    alt: "dr ramkumar",
  },
  event03: {
    image: require("./images/home/prabhavati_dwabha.png"),
    alt: "event",
  },
  event04: {
    image: require("./images/home/gurmukh.png"),
    alt: "gurmukh",
  },
  event05: {
    image: require("./images/home/monika.png"),
    alt: "monika",
  },
  event06: {
    image: require("./images/home/season_2_episode_5_home.jpg"),
    alt: "Marouf Tirad",
  },
  reflection01: {
    image: require("./images/home/reflection-01.jpg"),
    alt: "reflection 01",
  },

  testimonial01: {
    image: require("./images/home/testimonial/Ra.png"),
    alt: "testimonial",
  },
  testimonial02: {
    image: require("./images/home/testimonial/Annemarie_Brown.png"),
    alt: "testimonial",
  },
  testimonial03: {
    image: require("./images/home/testimonial/Monika_Vijh.png"),
    alt: "testimonial",
  },
  testimonial04: {
    image: require("./images/home/testimonial/Charlotte_Holmes.png"),
    alt: "testimonial",
  },

  // About us page Images
  mission: {
    image: require("./images/about-us/mission_back.png"),
    alt: "mission",
  },
  vision: {
    image: require("./images/about-us/vission_back.png"),
    alt: "mission",
  },
  founder: {
    image: require("./images/about-us/Mth_Marouf_Sattva.png"),
    alt: "mission",
  },
  partner01: {
    image: require("./images/about-us/Mani.png"),
    alt: "Mani",
  },
  partner02: {
    image: require("./images/about-us/Moria.png"),
    alt: "Mani",
  },
  partner03: {
    image: require("./images/about-us/Mani.png"),
    alt: "Mani",
  },
  partner04: {
    image: require("./images/about-us/Moria.png"),
    alt: "Mani",
  },
  partner05: {
    image: require("./images/about-us/Moria.png"),
    alt: "Mani",
  },
  partner06: {
    image: require("./images/about-us/Mani.png"),
    alt: "Mani",
  },
  partner07: {
    image: require("./images/about-us/Moria.png"),
    alt: "Mani",
  },
  partner08: {
    image: require("./images/about-us/Mani.png"),
    alt: "Mani",
  },

  // Reflections Images
  mainPost: {
    image: require("./images/Reflections/reflections.jpeg"),
    alt: "young-attractive-slim-woman",
  },
  mostPost01: {
    image: require("./images/Reflections/most_post.png"),
    alt: "most post",
  },
  mostPostMb01: {
    image: require("./images/Reflections/most_post_mb.png"),
    alt: "most post",
  },

  catPost01: {
    image: require("./images/Reflections/woman-doing-yoga.png"),
    alt: "post category",
  },
  catPostMb01: {
    image: require("./images/Reflections/woman-doing-yoga_mb.png"),
    alt: "post category",
  },
  catPost02: {
    image: require("./images/Reflections/multiracial-group.png"),
    alt: "post category",
  },
  catPostMb02: {
    image: require("./images/Reflections/multiracial-group_mb.png"),
    alt: "post category",
  },
  catPost03: {
    image: require("./images/Reflections/man-meditating.png"),
    alt: "post category",
  },
  catPostMb03: {
    image: require("./images/Reflections/man-meditating_mb.png"),
    alt: "post category",
  },
  catPost04: {
    image: require("./images/Reflections/austria-kranzhorn.png"),
    alt: "post category",
  },
  catPostMb04: {
    image: require("./images/Reflections/austria-kranzhorn_mb.png"),
    alt: "post category",
  },

  sustainabilityFashion: {
    image: require("./images/Reflections/reflections-inner/young.png"),
    alt: "Young",
  },
  sustainabilityFashionMb: {
    image: require("./images/Reflections/reflections-inner/young_mb.png"),
    alt: "Young",
  },
  paginationPost01: {
    image: require("./images/Reflections/reflections-inner/woman-doing-youga.png"),
    alt: "Young",
  },
  paginationPost02: {
    image: require("./images/Reflections/reflections-inner/woman-doing-youga.png"),
    alt: "Young",
  },

  // Interviews images
  interview01: {
    image: require("./images/interviews/tommy_rosen_1.jpg"),
    alt: "tommy rosen",
  },
  interviewMB01: {
    image: require("./images/interviews/tommy_rosen_mb_1.jpg"),
    alt: "tommy rosen",
  },
  interview02: {
    image: require("./images/interviews/young-sports-lady-beach.png"),
    alt: "young sports lady beach",
  },
  interviewMB02: {
    image: require("./images/interviews/young-sports-lady-beach_mb.png"),
    alt: "young sports lady beach",
  },
  interview03: {
    image: require("./images/interviews/dr_ramkumar_1.jpg"),
    alt: "dr ramkumar",
  },
  interviewMB03: {
    image: require("./images/interviews/dr_ramkumar_mb_1.jpg"),
    alt: "dr ramkumar",
  },
  interview04: {
    image: require("./images/interviews/prabhavati_dwabha_1.jpg"),
    alt: "prabhavati dwabha",
  },
  interviewMB04: {
    image: require("./images/interviews/prabhavati_dwabha_mb_1.jpg"),
    alt: "prabhavati dwabha",
  },
  interview05: {
    image: require("./images/interviews/austria-kranzhorn.png"),
    alt: "austria",
  },
  interviewMB05: {
    image: require("./images/interviews/austria-kranzhorn_mb.png"),
    alt: "austria",
  },
  interview06: {
    image: require("./images/interviews/young-attractive-slim-woman-doing-sport.png"),
    alt: "austria",
  },
  interviewMB06: {
    image: require("./images/interviews/young-attractive-slim-woman-doing-sport_mb.png"),
    alt: "austria",
  },
  interview07: {
    image: require("./images/interviews/austria-kranzhorn.png"),
    alt: "austria",
  },
  interviewMB07: {
    image: require("./images/interviews/austria-kranzhorn_mb.png"),
    alt: "austria",
  },
  interview08: {
    image: require("./images/interviews/austria-kranzhorn.png"),
    alt: "austria",
  },
  interviewMB08: {
    image: require("./images/interviews/austria-kranzhorn_mb.png"),
    alt: "austria",
  },
  interview09: {
    image: require("./images/interviews/young-sports-lady-beach.png"),
    alt: "austria",
  },
  interviewMB09: {
    image: require("./images/interviews/young-sports-lady-beach_mb.png"),
    alt: "austria",
  },
  interview10: {
    image: require("./images/interviews/gurmukh_1.jpg"),
    alt: "prabhavati dwabha",
  },
  interviewMB10: {
    image: require("./images/interviews/gurmukh_mb_1.jpg"),
    alt: "prabhavati dwabha",
  },
  interview11: {
    image: require("./images/interviews/monika_1.jpg"),
    alt: "monika",
  },
  interviewMB11: {
    image: require("./images/interviews/monika_mb_1.jpg"),
    alt: "monika",
  },
  interview12: {
    image: require("./images/interviews/Marianna_1.jpg"),
    alt: "Marianna",
  },
  interviewMB12: {
    image: require("./images/interviews/Marianna_mb_1.jpg"),
    alt: "Marianna",
  },
  interview13: {
    image: require("./images/interviews/lama_ahbay_1.jpg"),
    alt: "Geshe Lama Ahbay Tulku Rinpoche",
  },
  interviewMB13: {
    image: require("./images/interviews/lama_ahbay_mb_1.jpg"),
    alt: "Geshe Lama Ahbay Tulku Rinpoche",
  },
  interview14: {
    image: require("./images/interviews/charlotte_homes.jpg"),
    alt: "charlotte homes",
  },
  interviewMB14: {
    image: require("./images/interviews/charlotte_homes_mb.jpg"),
    alt: "charlotte homes",
  },
  interview15: {
    image: require("./images/interviews/Joelle_lahlouh.jpg"),
    alt: "Joelle lahlouh",
  },
  interviewMB15: {
    image: require("./images/interviews/Joelle_lahlouh_mb.jpg"),
    alt: "Joelle lahlouh",
  },
  interview16: {
    image: require("./images/interviews/verdic_astrology.jpg"),
    alt: "verdic astrology",
  },
  interviewMB16: {
    image: require("./images/interviews/verdic_astrology_mb.jpg"),
    alt: "verdic astrology",
  },
  interview17: {
    image: require("./images/interviews/Mike_Chang.jpg"),
    alt: "verdic astrology",
  },
  interviewMB17: {
    image: require("./images/interviews/Mike_Chang_mb.jpg"),
    alt: "verdic astrology",
  },
  interview18: {
    image: require("./images/interviews/Aaron_Kleinerman.jpg"),
    alt: "verdic astrology",
  },
  interviewMB18: {
    image: require("./images/interviews/Aaron_Kleinerman_mb.jpg"),
    alt: "verdic astrology",
  },
  interview19: {
    image: require("./images/interviews/ibu_robin.jpg"),
    alt: "ibu robin",
  },
  interviewMB19: {
    image: require("./images/interviews/ibu_robin_mb.jpg"),
    alt: "ibu robin",
  },
  interview20: {
    image: require("./images/interviews/Niraj_naik.jpg"),
    alt: "ibu robin",
  },
  interviewMB20: {
    image: require("./images/interviews/Niraj_naik_mb.jpg"),
    alt: "ibu robin",
  },
  interview21: {
    image: require("./images/interviews/season_2_episode_5.jpg"),
    alt: "Marouf Tirad",
  },
  interviewMB21: {
    image: require("./images/interviews/season_2_episode_5_mb.jpg"),
    alt: "Marouf Tirad",
  },
};
